<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="introduction">
<p style="padding: 200px 0 0 0; text-align: center;">It is to all who suffer, I come</p>
<p style="text-align: center;">to confide and share the story of little</p>
<p style="text-align: center;">Danielle Nichole Therese Martinez</p><br/>
<p style="text-align: center;">I pray the Holy Spirit will inspire my</p>
<p style="text-align: center;">writings and give me the strength to</p>
<p style="text-align: center;">endure them.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Section0001.vue?12378ada